/**
 * TanStack Query hooks for `native-snowflake-direct-connector`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	nativeSnowflakeDirectConnectorQueryKeys,
	type CreateNativeSnowflakeDirectConnectorBody,
	type ListNativeSnowflakeDirectConnectorResponse,
	type NativeSnowflakeDirectConnectorRow,
} from "./api";

export function useNativeSnowflakeDirectConnectorList(): UseQueryResult<ListNativeSnowflakeDirectConnectorResponse, Error> {
	return useQuery({
		queryKey: nativeSnowflakeDirectConnectorQueryKeys.list(),
		queryFn: list,
	});
}

export function useNativeSnowflakeDirectConnectorCreate(): UseMutationResult<NativeSnowflakeDirectConnectorRow, Error, CreateNativeSnowflakeDirectConnectorBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: nativeSnowflakeDirectConnectorQueryKeys.all });
		},
	});
}

export function useNativeSnowflakeDirectConnectorDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: nativeSnowflakeDirectConnectorQueryKeys.all });
		},
	});
}
